module.exports = __webpack_public_path__ + "static/img/LuongThiTram.4b29f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LuongThiTram.png
// module id = meX5
// module chunks = 1